import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/api';
import { NewmemberService } from '../../services/newmember.service';
import { DuplicateLicenseComponent } from '../duplicate-license/duplicate-license.component';
import { DialogService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { DocuploadComponent } from '../docupload/docupload.component';
import { isNull } from 'util';
import { DatePipe } from '@angular/common';
import { DigitalDeclarationComponent } from '../digitaldeclaration/digitaldeclaration.component';

@Component({
  selector: 'app-detailform',
  templateUrl: './detailform.component.html',
  styleUrls: ['./detailform.component.css'],
  providers: [DialogService]
})
export class DetailformComponent implements OnInit {

  licBlock: RegExp = /^[^<>*!@#$_%+=~`^{};:.,&|?\[\]'"]+$/;
  populateForm: any = {};
  bdForm: FormGroup;
  bdFormValid: boolean = true;
  docUpdated: boolean = false;
  bd: any = {};
  selectedLicence = [];
  uploadedFiles: any = {};
  currentDate: any;
  eMaxLimit: any;
  yearRange: any;
  declDocumentType: string;
  declFileName: string;
  isDeclToUploaded: boolean = false;
  proof = [];
  hardStopLicenseType = [];
  businessLicenseType: any = [];
  smallOfficeOptions: any = [];
  smallOfficeType: string;
  isSmallOffice: boolean = false;
  BDverified: boolean;
  declareAddonVerified: boolean;
  declareVerified : boolean=false;;
  primaryMemberInfo: any;
  hardStop: boolean = false;
  validateFailed: boolean = false;
  licenseVerify = [];
  thirdPartyCheck: string = "";

  @ViewChild("supportDocuments") private supportDocuments: DocuploadComponent;

  constructor(private datePipe: DatePipe, public ref: DynamicDialogRef, public config: DynamicDialogConfig, public dialogService: DialogService, public nms: NewmemberService, public confirmationService: ConfirmationService, public messageService: MessageService) { }

  ngOnInit() {
    this.currentDate = new Date(localStorage.getItem('currDate'));
    let temp1 = new Date(localStorage.getItem('currDate'));
    this.eMaxLimit = new Date(temp1.setFullYear(temp1.getFullYear() + 99));
    this.yearRange = this.currentDate.getFullYear() + ":" + this.eMaxLimit.getFullYear();
    this.populateForm = this.config.data.populateForm;
    this.bd.businessName = this.config.data.memberDetails.businessName;
    this.bd.segmentCode = this.config.data.memberDetails.segmentCode;
    this.BDverified= false;
    this.primaryMemberInfo = this.nms.primaryMemberInfo;

    this.bd.supportingDocuments = [];
    this.bd.supportingDocuments = this.config.data.memberDetails.supportingDocuments;
    if (this.bd.supportingDocuments != null && this.bd.supportingDocuments.length > 0) {
      this.declDocumentType = this.bd.supportingDocuments[0].documentType;
      this.isDeclToUploaded = true;
      this.uploadedFiles.supportingDocuments = [];
      let temp: any = this.bd.supportingDocuments[0];
      temp.ustatus = this.bd.supportingDocuments[0].documentId != null ? true : false;;
      this.uploadedFiles.supportingDocuments[0] = temp;
    } else {
      this.bd.supportingDocuments = [];
    }

    this.bd.sicCode = this.config.data.memberDetails.sicCode;
    this.bd.taxExemption = this.config.data.memberDetails.taxExemption ? this.config.data.memberDetails.taxExemption : false;
    this.bd.ownerNameNotVisible = this.config.data.memberDetails.ownerNameNotVisible ? this.config.data.memberDetails.ownerNameNotVisible : false;
    if (this.config.data.memberDetails.memberBusinessLicense) {
      this.bd.businessLicenseParamsList = this.config.data.memberDetails.memberBusinessLicense;
      this.selectedLicence = [];
      this.uploadedFiles.businessLicenseParamsList = [];
      for (let list of this.bd.businessLicenseParamsList) {
        var license = this.populateForm.businessLicense.filter(proj => proj.code === list.licenseType);
        if (license != null && license.length > 0) {
          this.businessLicenseType.push(list);
        this.selectedLicence.push(list.licenseType);
        let temp: any = list;
        temp.documentType = list.licenseType;
        temp.ustatus = list.documentId != null ? true : false;
        this.uploadedFiles.businessLicenseParamsList.push(temp);
        for (let list1 of this.populateForm.businessLicense) {
          if (list1.code == list.licenseType) {
            list.name = list1.text;
            list.defaultExpiryYear = list1.defaultExpiryYear;
            list.maxLength = list1.maxLength;
            if (list1.defaultExpiryYear > 0 && this.config.data.memberDetails.startDate != null){
              let startDate = new Date(this.config.data.memberDetails.startDate);
              let expDate = new Date(startDate.setFullYear(startDate.getFullYear() + list.defaultExpiryYear));
              list.expirationDate = this.datePipe.transform(expDate, 'yyyy-MM-dd');
            }
          }
        }
      }
    }
      this.bd.businessLicenseParamsList = this.businessLicenseType;
    }
    if (this.config.data.memberDetails.authorizationDocument) {
      this.bd.authorizationDocument = this.config.data.memberDetails.authorizationDocument;
      this.uploadedFiles.authorizationDocument = [];
      let temp: any = this.bd.authorizationDocument;
      temp.ustatus = this.bd.authorizationDocument.documentId != null ? true : false;
      this.uploadedFiles.authorizationDocument[0] = temp;
    }
    
    this.bdForm = new FormGroup({
      businesstype: new FormControl('', Validators.compose([
        Validators.required
      ])),
      businessName: new FormControl('', Validators.compose([
        Validators.required
      ])),      
      smallOfficeType: new FormControl(),
      businessnature: new FormControl('', Validators.compose([
        Validators.required
      ])),
      Lic_0: new FormControl(),
      Lic_1: new FormControl(),
      Lic_2: new FormControl(),
      expiry_0: new FormControl(),
      expiry_1: new FormControl(),
      expiry_2: new FormControl(),
      state_0: new FormControl(),
      state_1: new FormControl(),
      state_2: new FormControl(),
      MultiSelect: new FormControl('', Validators.compose([
        Validators.required
      ])),
      isBusinessOwnerNameGiven: new FormControl(false),
      isTaxExemption: new FormControl(false),
      declareattestation: new FormControl(),
    });
    if (this.config.data.memberDetails.memberBusinessLicense) {
      for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
        if(this.bd.businessLicenseParamsList[i].maxLength > 0) {
          this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+this.bd.businessLicenseParamsList[i].maxLength+'}$')]);
        } else {
          this.bdForm.get('Lic_' + i).setValidators([Validators.required]);
        }
      }
    }
    let temp = new Date(localStorage.getItem('currDate'));
    this.eMaxLimit = new Date(temp.setFullYear(temp.getFullYear() + 99));
    this.ddCheck();
    this.smallOfficeType = this.declDocumentType;
    this.nms.declDocumentType = this.declDocumentType;
    this.smallOfficeDropChange();
  }

  btypeChange() {
    this.bd.sicCode = "";
    this.ddCheck();
  }
  
  onChangeMethod(i) {
    this.proof[i] = 0;
  }

  onBlurMethod(type, index) {
    this.proof[index] = 0;
    if (this.bdForm.get('Lic_' + index).value) {
      if (type == "GST REGISTRATION" && this.bdForm.get('Lic_' + index).value.length == 15) {
        this.nms.validateGST(this.bdForm.get('Lic_' + index).value).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            //if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
             // this.proof[index] = "VALID";
          //  } else if (res.response.status == "PROVISIONAL" || res.response.status == "CANCELLED") {
           //   this.proof[index] = "INVALID";
           // } else {
              this.proof[index] = res.response.statusCode;
              this.licenseVerify['GST'] = res.response.statusCode;
           // }
            this.populateLicenceDetails(res, index, type);
          } else {
            this.licenseVerify['GST'] = 'RETRY_ERROR';
            this.validateFailed = true;
            this.proof[index] = "Failed";
            //this.hardStopLicenseType[type] = true;
          }
        }, err => {
          this.licenseVerify['GST'] = 'RETRY_ERROR';
          this.validateFailed = true;
          this.proof[index] = "Failed";
          //this.hardStopLicenseType[type] = true;
        });
      } else if (type == "UDYOG AADHAAR" && this.bdForm.get('Lic_' + index).value.length == 12) {
        this.nms.validateUAN(this.bdForm.get('Lic_' + index).value).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
              this.proof[index] = "VALID";
            } else if (res.response.status == "PROVISIONAL" || res.response.status == "CANCELLED") {
              this.proof[index] = "INVALID";
            } else {
              this.proof[index] = res.response.statusCode;
            }
            this.populateLicenceDetails(res, index, type);
          } else {
            this.validateFailed = true;
            this.proof[index] = "Failed";
            //this.hardStopLicenseType[type] = true;
          }
        }, err => {
          this.validateFailed = true;
          this.proof[index] = "Failed";
          //this.hardStopLicenseType[type] = true;
        });
      }
    }
  }

  
  smallOfficeDropChange() {
    var smallOffice = this.smallOfficeOptions.filter(proj => proj.licenseType === this.smallOfficeType);

    if (smallOffice.length > 0) {
      this.declDocumentType = smallOffice[0].documentName;
      this.declFileName = smallOffice[0].licFileName;
      this.nms.declDocumentType = this.declDocumentType;
      this.isDeclToUploaded = true;

      if (this.bd && this.bd.supportingDocuments && this.bd.supportingDocuments.length > 0) {
        this.declarationChanged(this.bd.supportingDocuments[0].documentType);
      }      
    }
  }

  ddCheck() {
    var isDeclarationChanged = false;
    var existingDocumentType = null;
    this.smallOfficeOptions = [];
    this.smallOfficeType = null;
    var smallOfficeOption: any = {};

    this.isSmallOffice = this.bd.segmentCode === 'O&I-BUSINESS SERVICES' ? true : false;

    if (this.bd && this.bd.supportingDocuments && this.bd.supportingDocuments.length > 0) {
      existingDocumentType = this.bd.supportingDocuments[0].documentType;
    }

    var declarationDoc = this.populateForm.DeclarationDocuments;
    this.isDeclToUploaded = false;
    for (var docIndex in declarationDoc) {
      if (declarationDoc[docIndex].segmentCode == this.bd.segmentCode) {
        if (declarationDoc[docIndex].fileName != null) {
          this.declDocumentType = declarationDoc[docIndex].documentName;
          this.nms.declDocumentType = this.declDocumentType;
          this.declFileName = declarationDoc[docIndex].fileName;
          this.isDeclToUploaded = true;

        } else if (declarationDoc[docIndex].licenseDeclarations != null) {
          var licenseDeclarations = declarationDoc[docIndex].licenseDeclarations;
          
          for (var declIndex in licenseDeclarations) {
              var license = this.populateForm.businessLicense.filter(proj => proj.code === licenseDeclarations[declIndex].licenseType);
              
              if (license.length == 0) {
                this.smallOfficeOptions.push(licenseDeclarations[declIndex]);
              }
          }
          this.smallOfficeOptions.sort((a,b) => a.licenseType.localeCompare(b.licenseType));
        }
        break;
      }
    }
    this.declarationChanged(existingDocumentType);
  }

  declarationChanged(existingDocumentType) {
    var isDeclarationChanged = false;
    if (existingDocumentType != this.declDocumentType) {
      this.nms.declDocumentType = this.declDocumentType;
      isDeclarationChanged = true;
    }
    if (isDeclarationChanged) {
      this.bd.supportingDocuments = [];
      this.uploadedFiles.supportingDocuments = null;
      if (this.supportDocuments != null) {
        this.supportDocuments.reset();
      }

    }
  }

  ustatusUpdate(event, group, type) {
    if (event) {
      this.docUpdated = true;
    }
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
    } else {
      let check = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          check = 1;
          list.ustatus = event;
        }
      }
      if (check == 0) {
        this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
      }
    }
  }

  updateUploadstatus(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
    } else {
      let done = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          list.documentId = event.documentId;
          done = 1;
        }
      }
      if (done == 0) {
        this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
      }
    }
  }

  
  populateLicenceDetails(res, index, type) {
    if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
      //this.msgToastInfo('Business name, License state and business address are populated using GSP service');
      this.bd.businessName = res.response.businessName;
      let stateFound = 0;
      let cityFound = 0;
      if (res.response.city == "") {
        cityFound = 1;
      }
      for (let l of this.populateForm.StateCityList) {
        if (l.stateName == res.response.state && stateFound == 0) {
          this.bd.businessLicenseParamsList[index].stateProvCode = l.stateName;
          stateFound = 1;
        }        
        if (stateFound == 1) {
          break;
        }
      }
      this.hardStopLicenseType[type] = false;
    } else if (res.response.statusCode == "INVALID" || res.response.status == "PROVISIONAL") {
      this.hardStopLicenseType[type] = true;
      if (res.response.errorMessage != null) {
        this.msgToastInfo(res.response.errorMessage);
      }      
    }  else {
      this.msgToastInfo("GST Portal is down, Please manually enter or try later.");
      this.hardStopLicenseType[type] = false;
    }
  }

  updateLicenceList(event) {
    var removeItem = 1;
    for (let val of event.value) {
      if (event.itemValue == val) {
        removeItem = 0;
      }
    }
    if (removeItem == 1) {
      var temp_obj = JSON.parse(JSON.stringify(this.bd.businessLicenseParamsList));
      this.bd.businessLicenseParamsList = [];
      for (var i = 0; i < temp_obj.length; i++) {
        if (temp_obj[i].licenseType == event.itemValue) {  
          if (event.itemValue == "GST") {
            this.hardStopLicenseType["GST REGISTRATION"] = false;
          } else if (event.itemValue == "UAN") {
            this.hardStopLicenseType["UDYOG AADHAAR"] = false;
          }        
          temp_obj.splice(i, 1);
          this.proof[i] = 0;
          break;
        }
        /*if(temp_obj[i].expirationDate && temp_obj[i].expirationDate != '') {
          var date = new Date(temp_obj[i].expirationDate);
          var day = date.getDate();
          var monthIndex = date.getMonth();
          var year = date.getFullYear();
          temp_obj[i].expirationDate = year + '-' + monthIndex + '-' + day;
        }*/
      }
      for (var i = 0; i < temp_obj.length; i++) {
        if(temp_obj[i].expirationDate && temp_obj[i].expirationDate != '') {
          var date = new Date(temp_obj[i].expirationDate);
          var yestDateStr = this.datePipe.transform(date, 'yyyy-MM-dd');
          temp_obj[i].expirationDate = yestDateStr;
        }
      }
      this.bd.businessLicenseParamsList = temp_obj;
       
      this.bdForm.updateValueAndValidity();
      for (var index = 0; index < 3; index++) {
          this.bdForm.get('Lic_' + index).setValidators(null);
          this.bdForm.get('Lic_' + index).updateValueAndValidity();
      }

      for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
        let obj = {}
        obj['Lic_'+i] = this.bd.businessLicenseParamsList[i].licenseNumber?this.bd.businessLicenseParamsList[i].licenseNumber:'';
        obj['expiry_'+i] = this.bd.businessLicenseParamsList[i].expirationDate?this.bd.businessLicenseParamsList[i].expirationDate:'';
        obj['state_'+i] = this.bd.businessLicenseParamsList[i].stateProvCode?this.bd.businessLicenseParamsList[i].stateProvCode:'';        
        this.bdForm.patchValue(obj);
        this.bdForm.updateValueAndValidity();
        if(this.bd.businessLicenseParamsList[i].maxLength > 0) {
          this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+this.bd.businessLicenseParamsList[i].maxLength+'}$')]);
          this.bdForm.get('Lic_' + i).updateValueAndValidity();
        } else {
          this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]+$')]);
          this.bdForm.get('Lic_' + i).updateValueAndValidity();
        }
      }
      for(var i = 0; i < this.uploadedFiles['businessLicenseParamsList'].length; i++){
        if (this.uploadedFiles['businessLicenseParamsList'][i].documentType == event.itemValue) {          
          this.uploadedFiles['businessLicenseParamsList'].splice(i, 1);
          this.proof[i] = 0;
          break;
        }
      }
    } else {
      if (!this.isDeclToUploaded) {
        this.isDeclToUploaded = true;
      }
      for (let list of this.populateForm.businessLicense) {
        if (list.code == event.itemValue) {
          if (list.defaultExpiryYear > 0 && this.config.data.memberDetails.startDate != null){
            
            let startDate = new Date(this.config.data.memberDetails.startDate);
            let expDate = new Date(startDate.setFullYear(startDate.getFullYear() + list.defaultExpiryYear));
            this.bd.businessLicenseParamsList.push({ "name": list.text, "licenseType": list.code, "expirationDate": expDate, "defaultExpiryYear": list.defaultExpiryYear, "maxLength": list.maxLength });
          } else {
            
            this.bd.businessLicenseParamsList.push({ "name": list.text, "licenseType": list.code, "defaultExpiryYear": list.defaultExpiryYear, "maxLength": list.maxLength });
          }
          if(list.maxLength > 0) {
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).updateValueAndValidity();
          } else {
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).setValidators([Validators.required]);
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).updateValueAndValidity();
          }
        }
      }
      if (!this.uploadedFiles['businessLicenseParamsList']) {
        this.uploadedFiles['businessLicenseParamsList'] = [];
        this.uploadedFiles['businessLicenseParamsList'].push({ "ustatus": false, "documentType": event.itemValue });
      } else {
        let check = 0;
        for (let list of this.uploadedFiles['businessLicenseParamsList']) {
          if (list.documentType == event.itemValue) {
            check = 1;
            list.ustatus = false;
          }
        }
        if (check == 0) {
          this.uploadedFiles['businessLicenseParamsList'].push({ "ustatus": false, "documentType": event.itemValue });
        }
      }
    }
    this.ddCheck();
  }

  saveBD() {
    if (this.hardStopLicenseType["GST REGISTRATION"] || this.hardStopLicenseType["UDYOG AADHAAR"]) {
      this.hardStop = true;
    } else {
      this.hardStop = false;
    }
    if (this.bdForm.valid && !this.hardStop && this.bd.businessName.length <= 50) {
      for (let doc of this.bd.businessLicenseParamsList) {
        if (!doc.licenseNumber || doc.licenseNumber == "") {
          this.bdFormValid = false;
          return;
        }
        if (this.uploadedFiles.businessLicenseParamsList) {
          for (let list of this.uploadedFiles.businessLicenseParamsList) {
            if (!list.ustatus) {
              this.bdFormValid = false;
              return;
            }
            if (list.documentType == doc.licenseType) {
              doc.documentId = list.documentId;
            }
            doc.thirdPartyCheck  = this.licenseVerify[doc.licenseType] ? this.licenseVerify[doc.licenseType] : doc.thirdPartyCheck ? doc.thirdPartyCheck : null;
          }
        } else {
          this.bdFormValid = false;
          return;
        }
      }
      if (this.bd.ownerNameNotVisible) {
        if (!this.uploadedFiles.authorizationDocument || !this.uploadedFiles.authorizationDocument[0].ustatus) {
          this.bdFormValid = false;
          return;
        }
        this.bd.authorizationDocument = this.uploadedFiles.authorizationDocument[0];
      } else {
        this.bd.authorizationDocument = {};
      }

      if (this.isDeclToUploaded || this.isSmallOffice) {
        // if (!this.uploadedFiles.supportingDocuments || this.uploadedFiles.supportingDocuments.length == 0
        //   || !this.uploadedFiles.supportingDocuments[0].ustatus) {
        //     this.msgToast('Please fill all mandatory fields');
        //   this.bdFormValid = false;
        //   return;
        // }
        // this.bd.supportingDocuments = this.uploadedFiles.supportingDocuments;
        if(this.BDverified==false){
          this.bdFormValid = false;
          return;
        }
      } else {
        this.bd.supportingDocuments = [];
      }

      if (!this.bdForm.dirty && !this.docUpdated) {
        this.msgToast('No changes made');
        return;
      }

      if (this.config.data.action == "update") {
        this.nms.saveBD(this.bd).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            if (res.response.businessMembershipExist) {
              const ref = this.dialogService.open(DuplicateLicenseComponent, {
                data: res.response.duplicateMembership,
                header: 'Business License Already Exists',
                width: '50%',
                height: '80%',
                closeOnEscape: false
              });
              ref.onClose.subscribe((ignore) => {
                if (ignore){
                  this.ref.close(true);
                  this.msgToastInfo("Business License Already Exists, QC can be processed for this membership only by Store Admin.")
                }
              });
            } else if (res.response.isOCRValidated) {
              let popText: string;
              popText = '<div class="ocrPop"><div class="row"><div class="col-4"><h6>Document</h6></div><div class="col-4"><h6>Fields</h6></div><div class="col-4"><h6>Status</h6></div></div>';
              for (let list of res.response.memberBusinessLicense) {
                if (list.isLicenseNoOCRScreen != null || list.isBusinessNameOCRScreen != null || list.isDocumentNameOCRScreen != null) {
                  if (list.isLicenseNoOCRScreen == "false" || list.isBusinessNameOCRScreen == "false" || list.isDocumentNameOCRScreen == "false") {
                    let doc = "Match";
                    let bn = "Match";
                    let lic = "Match";
                    if (list.isLicenseNoOCRScreen == "false") { lic = 'Mismatch' }
                    if (list.isBusinessNameOCRScreen == "false") { bn = 'Mismatch' }
                    if (list.isDocumentNameOCRScreen == "false") { doc = 'Mismatch' }
                    popText = popText + '<div class="row"><div class="col-4">' + list.licenseType + '</div><div class="col-4"><div class="' + doc + '">Document</div><div class="' + bn + '">Business Name</div><div class="' + lic + '">License No</div></div>';
                    popText = popText + '<div class="col-4"><div class="' + doc + '">' + doc + '</div><div class="' + bn + '">' + bn + '</div><div class="' + lic + '">' + lic + '</div></div></div>';
                  }
                }
              }
              popText = popText + '</div>';
              this.confirmationService.confirm({
                message: popText,
                acceptLabel: 'Ignore',
                rejectLabel: 'Edit',
                accept: () => {
                  this.ref.close(true);
                }
              });
            } else {
              this.ref.close(true);
            }
          }
        }, err => {
          console.error('ERROR', err);
        });
      } else {
        
      }
    } else {
      if (!this.bdForm.valid) {
        this.bdFormValid = false;
        this.msgToast('Please fill all mandatory fields');
      }
      if (this.hardStop) {
        this.confirmationService.confirm({
          message: "Invalid license number entered",
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      } else if (this.validateFailed) {
        this.confirmationService.confirm({
          message: "License number validation failed",
          acceptLabel: 'Ignore',
          rejectLabel: 'Retry',
          accept: () => {
            this.validateFailed = false;
            this.saveBD();
          },
          reject: () => {
            this.retryValidation();
          }
        });
      } else {
        this.msgToast('Please fill all mandatory fields');
      }
      
    }
  }

  declareAddon() {
    const ref = this.dialogService.open(DigitalDeclarationComponent, {
      width: '95%',
      height: '80%',
      closeOnEscape: false,
      dismissableMask: true,
      styleClass: 'termWidth',
    });
    this.declareAddonVerified = true;
  }

  updateOTPstatus(event, id) {
     if (id == "BDverified") {
      this.BDverified = true;

    } 
  }

  declarationContactInfo() {
    var otpInfo: any = {};
    otpInfo.phoneNbr = this.primaryMemberInfo.phoneNbr;
    otpInfo.maMembershipId = this.nms.mlid;
    otpInfo.category = "DECLARATION_OTP_BP";
    otpInfo.apiType = "DECLARATION_OTP_SMS";
    otpInfo.email = this.primaryMemberInfo.email;
    return otpInfo;
  }

  retryValidation() {
    for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
      if (this.bd.businessLicenseParamsList[i].name == "GST REGISTRATION" || this.bd.businessLicenseParamsList[i].name == "UDYOG AADHAAR") {
        this.populateLicenceDetails(this.bd.businessLicenseParamsList[i].name, i, this.bd.businessLicenseParamsList[i].name);
      }
    }
  }

  msgToast(msg) {
    this.messageService.add({ severity: 'error', summary: 'Edit Member', detail: msg });
  }

  msgToastInfo(msg) {
    this.messageService.add({ severity: 'info', summary: 'Edit Member', detail: msg });
  }
}
